import React,{useEffect} from 'react';
import { Form, Button, Card } from 'react-bootstrap';
import { useNavigate,useParams } from "react-router-dom";
import { Formik } from 'formik';
import { toast } from 'react-toastify';
import { CategoryService } from '../../services';
import { useState } from 'react';
import Buttons from '../../components/Buttons';
import SelectInput from '../../components/SelectInput';
import CheckboxDropdownTree from '../../components/CheckboxDropdownTree';

const CategoryForm = (props) => {
    let navigate = useNavigate();
    let { id } = useParams();
    const [loading, setLoading] = useState(false);
    const [dataTree, setTreeData] = useState([]);
    const [parents, setParent] = useState([]);
    const [data, setData] = useState({ parent_id:0,name: '', description: '' });
  const loadData = async () => {
    setLoading(true);
    try {
      let response = await CategoryService.View({id});
      setData(response.data);      
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  }
  const reMap = item => {
    let {id,name,subcategory} = item;
    let obj = {
        label:name,value:id,children:[]
    }
    if(subcategory && subcategory.length>0){
        obj['children'] = subcategory.map(item => reMap(item))
    }
    return obj
  }
  useEffect(() => {
    loadData();
    CategoryService.Tree()
    .then(response => {
        //let tree_data = response.data.filter(item => item.parent_id === 0).map(item => reMap(item))
        setTreeData(response.data);
        //let parent = response.data.filter(item => item.parent_id === 0)
        //setParent(parent);
    })
    .catch(error => console.log(error)) 
  }, [])
  useEffect(() => {
    console.log('DATA',data)
  }, [data])
    return (
        <div className='form-container'>
        <Formik
            enableReinitialize={true}
            initialValues={data}
            validate={values => { 
                let errors = {}   
                if(parseInt(id)){
                    values = data
                }            
                if (!values.name) {
                    errors.name = 'Required';
                }
                return errors;
            }}
            onSubmit={async (values, { setSubmitting }) => {
                try {
                    let response = null;
                    if(parseInt(id)){ 
                        response = await CategoryService.Update({id,param:values});
                    } else {
                        response = await CategoryService.Create({param:values});
                    }
                    
                    const { success, message, data } = response;
                    if (success) {
                        toast.success(message);
                        return navigate("/categories");
                    }
                } catch (error) { 
                    if(!error.success && error.data){
                        Object.entries(error.data).forEach(([k,v]) => { 
                            toast.error(v[0]);
                        })
                    }
                }
                setTimeout(() => {
                    setSubmitting(false);
                }, 400);
            }}
        >
            {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting,
                /* and other goodies */
            }) => (
                <Card style={{width:'36rem'}}>
                    <Card.Header>Category Form</Card.Header>
                    <Card.Body>
                        <Form onSubmit={handleSubmit}>
                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                <Form.Label>Parent</Form.Label>                                
                                <CheckboxDropdownTree 
                                data={dataTree}
                                selected={values.parent_id||data.parent_id}
                                handler={setData}
                                value={values}
                                />
                                <Form.Text className="text-danger">
                                    {errors.parent_id && touched.parent_id && errors.parent_id}
                                </Form.Text>
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                <Form.Label>Name</Form.Label>
                                <Form.Control type="text"
                                    name="name"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.name||data.name}
                                    placeholder="Enter name" />
                                <Form.Text className="text-danger">
                                    {errors.name && touched.name && errors.name}
                                </Form.Text>
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                <Form.Label>Description</Form.Label>                                
                                    <Form.Control as="textarea" rows={3} 
                                    name="description"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.description||data.description}
                                    placeholder="Enter description"
                                    />
                                <Form.Text className="text-danger">
                                    {errors.description && touched.description && errors.description}
                                </Form.Text>
                            </Form.Group>
                            <Button variant="primary" type="submit" className='btn btn-primary' disabled={isSubmitting}>
                                Submit
                            </Button>{' '}
                           
                            <Buttons title="Cancle" type="link" url="/categories"/>
                        </Form>
                    </Card.Body>
                </Card>
            )}
        </Formik>
    </div>
    )
}

export default CategoryForm;